import Image from "next/image";
import Loading from "public/images/loading.gif";

function LoadingState(): JSX.Element {
  return (
    <div className="w-full flex place-content-center ">
      <div className="w-full flex place-content-center">
        <Image src={Loading} width={46} height={46} />
      </div>
    </div>
  );
}

export default LoadingState;
